import React from 'react';
import PropTypes from 'prop-types';

import DetailView from '../Common/DetailView';
import { Card, CardHeader, CardMedia, CardText, CardTitle } from 'material-ui/Card';
import Divider from 'material-ui/Divider';
import RaisedButton from 'material-ui/RaisedButton';
import { LauncherButton } from '../Elearning/Launcher';
import LinearProgress from 'material-ui/LinearProgress';
import ModuleBookingDialog from './ModuleBookingDialog';
import ConfirmDialog from '../Common/ConfirmDialog';
import ErrorSnackbar from '../Common/ErrorSnackbar';

import CpdSegment from './CpdSegment';
import EventSegment from './EventSegment';
import ModuleContentMain from './ModuleContentMain';
import SubscriptionSegment from './SubscriptionSegment';
import AssetSegment from '../Asset/AssetSegment';

import TrainerSegment from './TrainerSegment';
// icons
import EventIcon from 'material-ui/svg-icons/action/event';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import TimeLineIcon from 'material-ui/svg-icons/action/timeline';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import VideoIcon from 'material-ui/svg-icons/av/video-library';
import AudioIcon from 'material-ui/svg-icons/av/library-music';
import EnrolmentIcon from 'material-ui/svg-icons/action/check-circle';
// constants
import ROLES from '../../constants/Roles';
import { Verbs } from '../../constants/LRSConstants';
import { CommonDialogs } from '../../constants/Dialogs';
// business logic
import ModuleStore from '../../stores/ModuleStore';
import ModuleAssetStore from '../../stores/ModuleAssetStore';
import ModuleEventStore from '../../stores/ModuleEventStore';
import ModuleTrainerStore from '../../stores/ModuleTrainerStore';
import EventAttendeeStore from '../../stores/EventAttendeeStore';
import ModuleActions from '../../actions/ModuleActionCreator';
import EventActions from '../../actions/EventActionCreator';
import CourseActions from '../../actions/CourseActionCreator';
import DialogActions from '../../actions/DialogActionCreator';

import ModuleSubscriptionStore from '../../stores/ModuleSubscriptionStore';
import CourseModuleStore from '../../stores/CourseModuleStore';

import LRS from '../../utils/LRS';
import Markdown from 'react-markdown';

import buildContextMenu from '../Common/BuildContextMenu';
import { withId } from '../Common/Decorators';
import ElearningPlayerDialog from '../Elearning/ElearningPlayerDialog';

const style = {

    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',

    }
};

const getMenuItems = (id, data) => [

    {
        link: `/dashboard/module/${id}/events`,
        icon: <EventIcon />,
        label: 'Events',
        condition: {
            show: (!!data && data.type === 'classroom')
        }
    },
    {
        link: `/dashboard/module/${id}/calendar`,
        icon: <EventIcon />,
        label: 'Calendar',
        condition: {
            show: (!!data && data.type === 'classroom')
        }
    },
    {
        type: 'divider'
    },
    {
        link: `/dashboard/module/${id}/enrolments`,
        icon: <EnrolmentIcon />,
        label: 'Enrolments',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        link: `/dashboard/module/${id}/activity`,
        icon: <TimeLineIcon />,
        label: 'Activity',
        condition: {
            roles: [ROLES.ADMIN],
            show: (!!data && !!data.mediaId)
        }
    },
    {
        type: 'divider'
    },
    {
        link: `/dashboard/module/${id}/settings`,
        icon: <SettingsIcon />,
        label: 'Settings',
        condition: {
            roles: [ROLES.ADMIN],
        }
    },
    {
        type: 'divider'
    },
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    },
];

const Module = React.createClass({

    getInitialState: function(){

        return {
            details: {
                name: '',
                description: '',
                categoryName: '',
                categoryId: '',
                duration: '',
                code: '',
                capacity: '',
                cost: '',
                price: '',
                required: 0,
                type: '',
                mediaId: '',
                mediaName: '',
                mediaContent: '',
                validFrom: '',
                status: '',
                version: '',
                image: '',
                skillId: null,
                skillName: '',
                skillCode: '',
                skillLevel: '',
                eventAutoAttend: false
            },
            trainers: [],
            assets: [],
            skills: [],
            subscription: {},
            experienced: false,
            actions: [],
            links: {
                back: '/dashboard/library',
                edit: ''
            },
            upcomingEvents: [],
            booked: true,
            dialogOpen: false
        };
    },

    componentWillMount() {
        if (!this.props.courseId) {
            this.onChange();
        } else {
            this.onCourseModuleChange();
        }
        this._onModuleSubscriptionChange();
        this.onEventChange();
    },

    componentDidMount: function(){
        this.listeners = [
            ModuleSubscriptionStore.addListener(this._onModuleSubscriptionChange),
            ModuleEventStore.addListener(this.onModuleEventChange),
            EventAttendeeStore.addListener(this.onEventChange)
        ];

        if (!this.props.courseId) {
            this.listeners.push(ModuleStore.addListener(this.onChange));
            ModuleActions.getById(this.props.id);
        } else {
            this.listeners.push(CourseModuleStore.addListener(this.onCourseModuleChange));
            CourseActions.getModule(this.props.courseId, this.props.id);
        }


        ModuleAssetStore.addChangeListener(this.onAssetChange);
        ModuleActions.getAssets(this.props.id);

        ModuleTrainerStore.addChangeListener(this._onTrainerChange);
        ModuleActions.getTrainers(this.props.id);

        if (!!this.context.auth.identity && !!this.context.auth.identity.id) {
            ModuleActions.getSubscription(this.props.id, this.context.auth.identity.id);
        }

        ModuleActions.getEvents(this.props.id, {attendeeId: this.context.auth.identity.id, sort: 'timeStart', sortOrder: 'asc', startDate: new Date().toString().replace(/\s\([^)]+\)/, ''), status: 'active'});

        this.setState({
            moduleId: this.props.id,
            userId: this.context.auth.identity.id,
            actions: buildContextMenu(getMenuItems(this.props.id), this.context.auth)
        });
    },

    componentWillUnmount: function() {
        ModuleAssetStore.removeChangeListener(this.onAssetChange);
        ModuleTrainerStore.removeChangeListener(this._onTrainerChange);
        this.listeners.forEach(listener => listener.remove());
    },

    render: function() {

        const backLink = !!this.props.courseId
            ? `/dashboard/course/${this.props.courseId}?forceBack=true`
            : `/dashboard/library/${this.state.details.categoryId || 'uncategorised'}`;

        const viewProps = {
            title:      '',
            backButton: true,
            backTo:     backLink,
            forceBack:  !!this.props.courseId,
            actions:    this.state.actions
        };

        const showBookingButton = this.state.subscription.status !== 'enrolled' || (this.state.upcomingEvents && this.state.upcomingEvents.length > 0);
        const showCancelButton = this.state.subscription.status === 'enrolled' && !this.state.subscription.isAssigned;

        const eventData = {
            id:                 this.props.id,
            events:             this.state.details.type === 'classroom' ? this.state.upcomingEvents : null,
            booked:             this.state.booked,
            showAllEventsLink:  !this.state.booked && !this.state.details.eventAutoAttend && this.state.upcomingEvents.length > 10,
            bookingAction:      showBookingButton ? () => this.setState({dialogOpen: true}) : null,
            cancelAction:       showCancelButton ? this.saveSubscription.bind(this, 'cancelled') : null
        };

        const subscriptionData = {
            module:         this.state.details,
            subscription:   this.state.subscription || {},
            passMark:       !this.props.courseId ? this.state.details.required : this.state.details.requirement,
            mandatory:      !this.props.courseId ? this.state.subscription.isMandatory : this.state.details.mandatory
        };

        const CpdData = {
            cpdCredits:     Number(this.state.details.cpdCredits),
            skillId:        this.state.details.skillId,
            skillName:      this.state.details.skillName,
            skillCode:      this.state.details.skillCode,
            skillLevel:     this.state.details.skillLevel,
            passMark:       !this.props.courseId ? this.state.details.required : this.state.details.requirement,
        };

        const mainContentData = {
            module: this.state.details,
        };

        let enrolmentActions = [];

        if (this.state.details.status === 'active' && !this.props.courseId) {
            let userAction = '';
            if (!!this.state.subscription.loading) {
                enrolmentActions.push(<LinearProgress key="progress" mode="indeterminate" />);
            } else if (!!this.state.subscription.status) switch (this.state.subscription.status) {

                case 'enrolled':
                    userAction = 'cancel';
                    break;

                case 'assigned':
                    break;

                case 'cancelled':
                    if (this.state.details.visibility === 'public') {
                        userAction = 'enrol';
                    }
                    break;

                case 'completed':
                    if (this.state.details.visibility === 'public') {
                        userAction = 'enrol';
                    }
                    break;

                default:
                    if (this.state.details.visibility === 'public') {
                        userAction = 'enrol';
                    }
                    break;
            }
            if (userAction === 'enrol') {
                if (this.state.details.type !== 'classroom') {
                    enrolmentActions.push(
                        <RaisedButton
                            className="button-raised"
                            key="btn_enrol"
                            label="Enrol"
                            primary={true}
                            fullWidth={true}
                            onTouchTap={this.saveSubscription.bind(this, 'enrolled')}
                        />
                    );
                }
            } else if (userAction === 'cancel') {
                if (this.state.details.type !== 'classroom') {
                    enrolmentActions.push(
                        <RaisedButton
                            className="button-raised"
                            key="btn_cancel"
                            label="Cancel"
                            fullWidth={true}
                            onTouchTap={this.saveSubscription.bind(this, 'cancelled')}
                        />
                    );
                }
            }
        }

        let contentMedia;
        if (!!this.state.details.mediaContent) {
            contentMedia = (
                <div key='contentMedia'>
                    <Divider />
                    <CardText>
                        <Markdown source={this.state.details.mediaContent} />
                    </CardText>
                </div>
            );
        } else if (!!this.state.details.mediaAsAttachment) {
            switch (this.state.details.mediaType) {
                case 'e-learning':
                    break;
                case 'image':
                    contentMedia = (
                        <CardText style={{textAlign: "center"}} >
                            <img style={{maxWidth: "95%"}} src={this.state.details.mediaUrl} alt={this.state.details.filename} />
                        </CardText>
                    );
                    break;
                default:
                    if (!!this.state.details.mediaDownload) {
                        enrolmentActions.push(
                            <RaisedButton
                                key="btn_download"
                                className="button-raised"
                                label="Download"
                                fullWidth={true}
                                href={this.state.details.mediaDownload}
                            />
                        );
                    }
                    break;
            }
        }

        let header;

        if (this.state.details.type !== 'resource' && this.state.details.type !== 'video' && this.state.details.type !== 'audio') {
            const bannerContent = (
                <CardTitle title={this.state.details.name} subtitle={this.state.details.code} />
            );
            if (this.state.details.image !== '') {
                header = (
                        <CardMedia className="cent-card-media" overlay={bannerContent} >
                            <img src={this.state.details.image} />
                        </CardMedia>
                    );
            } else {
                header = bannerContent
            }
        } else {

            const colour = 'rgb(35, 151, 190)';
            let avatarIcon;
            switch (this.state.details.type) {
                case 'video':
                    avatarIcon = <VideoIcon style={style.icon} color={colour}/>;
                    break;
                case 'audio':
                    avatarIcon = <AudioIcon style={style.icon} color={colour}/>;
                    break;
                case 'resource':
                    avatarIcon = <LibraryIcon style={style.icon} color={colour}/>;
                    break;
                default:
                    break;
            }

            header = (
                <div>
                    <CardHeader
                        title={this.state.details.name}
                        subtitle={this.state.details.code}
                        avatar={avatarIcon}
                    />
                </div>
            );
        }

        // Display format

        switch (this.state.details.type) {

            case 'e-learning':
                if (!!this.state.subscription.status && !!this.state.details.published) {
                    enrolmentActions.unshift(
                        <LauncherButton
                            key="btn_launch"
                            data={this.state.subscription}
                            moduleVisibility={this.state.details.visibility}
                            courseId={this.state.details.id}
                            courseName={this.state.details.name}
                            asPopup={!!this.state.details.launchAsPopup}
                        />
                    );
                    if (this.state.subscription.status === 'completed' && (this.state.subscription.isAssigned || this.state.details.isRepeatable || this.state.details.visibility === 'public')) {
                        enrolmentActions.push(
                            <RaisedButton
                                key="btn_retake"
                                className="button-raised"
                                label="Retake"
                                secondary={true}
                                fullWidth={true}
                                onTouchTap={this.handleReset}
                            />
                        );
                    }
                }
                break;
            case 'video':
            case 'audio':
            case 'resource':

                if (!!this.state.subscription.status && this.state.subscription.status === 'enrolled') {
                    enrolmentActions.push(
                        <RaisedButton
                            key="btn_complete"
                            className="button-raised"
                            label="Complete"
                            secondary={true}
                            fullWidth={true}
                            onTouchTap={() => DialogActions.open(CommonDialogs.CONFIRM)}
                        />
                    );
                }
                break;

            default:
                break;
        }

        if (enrolmentActions.length > 0) {
            subscriptionData.actions = enrolmentActions;
        }

        return (
            <DetailView {...viewProps} >
                <div className="cent-cards">
                    <div className="cent-flex-column cent-col-8">
                        <Card className="cent-card">
                            {header}
                            <CardText>
                                <ModuleContentMain {...mainContentData} />
                            </CardText>
                            {contentMedia}
                        </Card>
                    </div>
                    <div className="cent-flex-column cent-col-4">
                        <SubscriptionSegment {...subscriptionData} />
                        {(this.state.details.type === 'resource') || <EventSegment {...eventData} />}
                        <CpdSegment {...CpdData} />
                        <TrainerSegment trainers={this.state.trainers} />
                        <AssetSegment assets={this.state.assets} />
                    </div>
                </div>
                <ModuleBookingDialog
                    open={this.state.dialogOpen}
                    events={this.state.upcomingEvents}
                    selectedEvent={Number(this.props.location.query.eventId) || null}
                    booked={this.state.booked}
                    confirmAction={this.handleBooking}
                    cancelAction={() => this.setState({dialogOpen: false})}
                />
                {(this.state.details.type === 'e-learning') && (
                    <ElearningPlayerDialog
                        moduleId={this.props.id}
                        title={this.state.details.name}
                        onClose={() => ModuleActions.getSubscription(this.props.id, this.context.auth.identity.id)}
                    />
                )}
                {(this.state.details.type === 'resource' || this.state.details.type === 'video' || this.state.details.type === 'audio') && (
                    <ConfirmDialog
                        title="Complete"
                        message={`You confirm that you have completed ${this.state.details.type === 'resource' ? 'reading' : 'viewing'} the provided material?`}
                        onConfirm={() => this.handleComplete()}
                        confirmButtonLabel="Yes"
                        cancelButtonLabel="No"
                    />
                )}
                <ErrorSnackbar/>
            </DetailView>
        );
    },

    onChange: function(){
        const details = ModuleStore.getById(this.props.id);
        if (details !== undefined) {
            this.setState({
                details,
                actions: buildContextMenu(getMenuItems(this.props.id, details), this.context.auth)
            });
        }
    },

    onCourseModuleChange: function() {
        const details = CourseModuleStore.getModule(this.props.courseId, this.props.id);
        if (!!details) {
            this.setState({details, actions: buildContextMenu(getMenuItems(this.props.id, details), this.context.auth)});
        }
    },

    _onModuleSubscriptionChange: function() {
        let subscription = ModuleSubscriptionStore.getSubscription(this.state.moduleId, this.state.userId);
        if (!!subscription) {
            this.setState({subscription});
        }
    },

    saveSubscription: function(status) {
        ModuleActions.saveSubscription(this.state.moduleId, this.state.userId, {status}, this.state.subscription);

        if (this.state.details.type === 'classroom' && status === 'cancelled') {
            this.setState({ booked: false, upcomingEvents: [] });
            ModuleActions.getEvents(this.props.id, {
                sort: 'timeStart',
                sortOrder: 'asc',
                startDate: new Date().toString().replace(/\s\([^)]+\)/, '')
            });
        }
    },

    onAssetChange: function() {
        const assets = ModuleAssetStore.getByModule(this.props.id);
        if (!!assets) {
            this.setState({assets: assets.filter((e) => e !== undefined && e.type !== 'e-learning')});
        }
    },

    _onTrainerChange: function() {
        const trainers = ModuleTrainerStore.getByModule(this.props.id);
        if (trainers !== undefined) {
            this.setState({trainers: trainers.filter((e) => !!e && e.status !== 'cancelled')});
        }
    },

    onModuleEventChange: function() {
        if (!!ModuleEventStore.isFetching()) { return; } //guard: fetching events

        if (!this.state.booked) {
            this.setState({upcomingEvents: ModuleEventStore.getNextAvailableEventsByModule(this.props.id, !this.state.details.eventAutoAttend ? 10 : 1, status = 'active')});
        } else {
            const upcomingEvents = ModuleEventStore.getNextEventsByAttendee(this.props.id, 10);
            if (upcomingEvents.length > 0) {
                this.setState({upcomingEvents});
            } else {
                this.setState({booked: false});
                ModuleActions.getEvents(this.props.id, {
                    limit: 10,
                    sort: 'timeStart',
                    sortOrder: 'asc',
                    startDate: new Date().toString().replace(/\s\([^)]+\)/, '')
                });
            }
        }
    },

    onEventChange: function() {
        // we don't really care about the data, although we should; we just react to it...
        let params = {
            sort: 'timeStart',
            startDate: new Date().toString().replace(/\s\([^)]+\)/, '')
        };
        if (this.state.booked) {
            params.attendeeId = this.context.auth.identity.id;
        }
        ModuleActions.getEvents(this.props.id, params);
    },

    // to be moved out later
    handleComplete: function() {
        const user = this.context.auth.getCurrentUser();
        const onSave = (user) => {
            if (this.state.subscription.status !== 'completed') {
                this.setState({
                    subscription: {
                        ...this.state.subscription,
                        status: 'completed',
                        loading: true
                    }
                });
                ModuleActions.saveSubscription(this.state.moduleId, Number(user.id), {status: 'completed', score: 100}, this.state.subscription);
            }
        };
        LRS.saveCustomStatement(user, Verbs.COMPLETED, { type: 'document', id: this.state.moduleId }, onSave.bind(this, user));
    },

    handleReset() {
        ModuleActions.resetSubscription(this.state.moduleId, this.context.auth.identity.id, this.state.subscription);
    },

    handleBooking: function(event) {
        const booked = this.state.booked && this.state.upcomingEvents.length > 1 ? true : !this.state.booked;
        if (this.state.booked !== booked) {
            if (booked) {
                this.saveSubscription('enrolled');
            } else if (!this.state.subscription.isAssigned) {
                this.saveSubscription('cancelled');
            }
        }

        if (!event && this.state.upcomingEvents.length === 1) {
            event = this.state.upcomingEvents[0].id;
        }
        if (!!event) {
            if (!this.state.booked) {
                ModuleActions.assignUsersToEvent(this.props.id, event, [this.context.auth.identity.id]);
            } else {
                EventActions.removeMyAttendance(event, {userId: this.context.auth.identity.id});
            }
        }
        this.setState({booked, dialogOpen: false});
    }
});

Module.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(Module, ({routeParams}) => ({
    id: Number(routeParams.id),
    courseId: Number(routeParams.courseId) || null,
}));
